import React from 'react';
import { EmptyState, EmptyStateBody } from '@patternfly/react-core';
import { MicrosoftIcon } from '@patternfly/react-icons';

/**
 * Microsoft 365 tab — placeholder until the backend exposes Microsoft 365 subscription data.
 */
function Microsoft365Tab() {
  return (
    <EmptyState titleText="Coming soon" icon={MicrosoftIcon} variant="lg" headingLevel="h2">
      <EmptyStateBody>
        Microsoft 365 subscription management is not yet available. We are currently working on this feature.
      </EmptyStateBody>
    </EmptyState>
  );
}

export default Microsoft365Tab;
